import stat_list from './list/router'
export default [{
    path: 'statistics',
    name: 'statistics',
    component: r => require.ensure([], () => r(require('./index.vue')), 'statistics'),
    children: [
        stat_list
    ]
}]
